import type { PropType } from 'vue'
import type { StepsDirection, StepsType, LineType } from './types'

/**
 * @description Steps Props
 */
export const stepsProps = {
  modelValue: {
    type: Number
  },
  /**
   * @description 步骤条的类型
   */
  type: {
    type: String as PropType<StepsType>,
    default: 'default'
  },
  /**
   * @description 步骤条的显示方向 默认水平
   */
  direction: {
    type: String as PropType<StepsDirection>,
    default: 'horizontal'
  },
  /**
   * @description 显示默认的步骤数（非受控状态）
   */
  defaultCurrent: {
    type: Number,
    default: 1
  },
  /**
   * @description 当前步骤数 (v-model)
   */
  current: {
    type: Number as PropType<number>,
    default: undefined
  },
  /**
   * @description 是否可以点击切换
   */
  changeable: {
    type: Boolean,
    default: false
  },
  /**
   * @description 轴线样式
   */
  lineType: {
    type: String as PropType<LineType>,
    default: 'dotted'
  }
}

/**
 * @description Step Props
 */
export const stepProps = {
  /**
   * @description 步骤的标题
   */
  title: {
    type: String,
    default: undefined
  },
  /**
   * @description 步骤的描述信息
   */
  description: {
    type: String,
    default: undefined
  },
  /**
   * @description 采用BN-ICON名称作为属性
   */
  icon: {
    type: String,
    default: undefined
  },
  /**
   * @description 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * @description 小圆点颜色
   */
  dotColor: {
    type: String
  }
}
